import { Collapse, Select, Tag } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import type { LambdaMethod } from '../../../../../@types/samples/types';
import { LAMBDA_METHODS } from '../methodConstants';
import { useTheme } from '../../../../../providers/theme';
import { getColors } from '../../../../utils/getColors';

type MethodHelpProps = {
  method: LambdaMethod;
  onChange: (method: LambdaMethod) => void;
  disabled?: boolean;
};

export function MethodHelp({ method, onChange, disabled }: MethodHelpProps) {
  const { isDay } = useTheme();
  const colors = getColors(isDay);

  const options = LAMBDA_METHODS.map(info => ({
    value: info.value,
    label: (
      <span>
        {info.label}
        {info.recommended && (
          <Tag color="green" style={{ marginLeft: 8 }}>
            recommended
          </Tag>
        )}
      </span>
    )
  }));

  return (
    <div
      style={{
        border: `1px solid ${colors.border}`,
        borderRadius: '12px',
        padding: '0.5rem 0.75rem',
        marginTop: '0.5rem',
        marginLeft: '0.5rem'
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          flexWrap: 'wrap'
        }}
      >
        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <QuestionCircleOutlined />
          Solver method:
        </span>
        <Select
          value={method}
          onChange={onChange}
          options={options}
          disabled={disabled}
          style={{ minWidth: 240 }}
          aria-label="Brooks-Corey solver method"
        />
      </div>

      <Collapse
        ghost
        style={{ marginTop: 8 }}
        items={LAMBDA_METHODS.map(info => ({
          key: info.value,
          label: (
            <span>
              {info.label}
              {info.recommended && (
                <Tag color="green" style={{ marginLeft: 8 }}>
                  recommended
                </Tag>
              )}
            </span>
          ),
          children: (
            <div style={{ color: colors.text }}>
              <p style={{ marginTop: 0 }}>{info.summary}</p>
              <strong>Pros</strong>
              <ul style={{ marginTop: 4 }}>
                {info.pros.map((pro, i) => (
                  <li key={`pro-${i}`}>{pro}</li>
                ))}
              </ul>
              <strong>Cons</strong>
              <ul style={{ marginTop: 4 }}>
                {info.cons.map((con, i) => (
                  <li key={`con-${i}`}>{con}</li>
                ))}
              </ul>
            </div>
          )
        }))}
      />
    </div>
  );
}
